import React from "react";

const SvgComponent = props => (
  <svg width={519} height={456} {...props}>
    <switch>
      <g>
        <path
          fill="#EFCE4A"
          d="M516 433.866c0 11.12-8.489 20.134-19.578 20.134H22.578C11.489 454 2 444.986 2 433.866V152h514v281.866z"
        />
        <path
          fill="#EBBA16"
          d="M2 22.134C2 11.014 11.489 2 22.578 2h189.844C225.5 2 232 6 232 22.134V152H2V22.134zM232 72h264.422C509.5 72 516 76 516 92.134V152H232V72z"
        />
      </g>
    </switch>
  </svg>
);

export default __webpack_public_path__ +
  "images/FolderIcon.1332423da83d2cbbcb91.svg";
export { SvgComponent as ReactComponent };
